import Header from "./Header";
import Footer from "./Footer";
import { Building2, BarChart3, CreditCard, FileText, Users, Globe, UserCheck } from "lucide-react";

const features = [
  { icon: Building2, title: "Multi-Business Switching", desc: "Manage multiple businesses from a single user account, each with its own books and settings." },
  { icon: BarChart3, title: "Dashboard", desc: "Get real-time insights into profit, expenses, income, and bank balances." },
  { icon: CreditCard, title: "Transactions Management", desc: "Record, categorize, and track every financial activity, manually or through bank feeds." },
  { icon: FileText, title: "Invoicing", desc: "Create and send professional invoices, track payments, and manage overdue bills." },
  { icon: FileText, title: "Bills & Expenses", desc: "Record recurring and one-time bills, monitor expenses by category or vendor." },
  { icon: Users, title: "Clients & Vendors", desc: "Manage customers and suppliers with smart tagging and contact info." },
  { icon: BarChart3, title: "Financial Reports", desc: "Automatically generate profit & loss, balance sheet, and cash flow reports." },
  { icon: Globe, title: "Bank Accounts", desc: "Connect or simulate bank accounts for viewing synced transactions." },
  { icon: UserCheck, title: "Team Management", desc: "Invite team members (e.g., accountant, manager), and assign role-based access." },
];

export default function About() {
  return (
    <div className="min-h-screen bg-blue-50 dark:bg-gray-900 flex flex-col">
      <Header />
      <main className="flex-1 w-full max-w-7xl mx-auto pt-28 pb-12 px-4">
        {/* About Text Section - concise, structured, smaller text */}
        <div className="max-w-2xl mx-auto mb-10 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-primary-blue mb-1">About Accurix</h1>
          <div className="text-sm md:text-base text-blue-700 dark:text-blue-400 font-semibold mb-3 tracking-wide uppercase">Modern Multi-Tenant Accounting & Finance</div>
          <p className="text-base md:text-lg text-gray-700 dark:text-gray-300 mb-2">
            Accurix is a modern, multi-tenant accounting and financial management SaaS application built to help startups, small businesses, and agencies manage their finances more efficiently across multiple companies — all from one place.
          </p>
        </div>
        {/* Features Grid Section */}
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-primary-blue mb-8 text-center dark:text-blue-400">What Makes Accurix Different?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="flex flex-col items-center bg-white dark:bg-gray-800 rounded-xl shadow-md p-5 border border-blue-100 dark:border-gray-700 h-full transition-transform hover:-translate-y-1 hover:shadow-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 dark:bg-blue-900/30 rounded-full mb-3">
                  <f.icon className="h-6 w-6 text-primary-blue" />
                </div>
                <div className="font-semibold text-base text-primary-blue mb-1 text-center">{f.title}</div>
                <div className="text-gray-600 dark:text-gray-400 text-sm text-center">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
